import copyObject from "./copy-object";

export default function sanitizeIO(value) {
	if (Array.isArray(value)) {
		return value.map(sanitizeIO);
	} else if ((typeof value === "object") && (value !== null)) {
		const objCopy = copyObject(value);
		for (let key in objCopy) {
			if (key.match(/^\$_|_id|_rev/)) {
				delete objCopy[key];
			} else {
				objCopy[key] = sanitizeIO(objCopy[key]);
			}
		}
		return objCopy;
	}
	return value;
}



// WEBPACK FOOTER //
// ./src/utils/sanitize-io.js